import { Injectable } from '@nestjs/common';
import { IdProofTypes } from '../id-proofs-type.entity';
import { IdProofTypesDTO } from './id-proof-types.dto';

@Injectable()
export class IdProofTypesAdapter {
  /**
   *
   * @param idProofTypesDTO
   * @returns IdProofTypes entity
   */
  public convertDtoToEntity(  idProofTypesDTO: IdProofTypesDTO,  isUpdate: boolean = false ): IdProofTypes {
    const idProofType = new IdProofTypes();
    idProofType.idProofTypeId=idProofTypesDTO.idProofTypeId;
    idProofType.idProofType=idProofTypesDTO.idProofType;
    idProofType.isActive=idProofTypesDTO.isActive==undefined?true:idProofTypesDTO.isActive;
    if (isUpdate) {
        idProofType.updatedUser = idProofTypesDTO.updatedUser;
    } else {
        idProofType.isActive = true;
        idProofType.createdUser = idProofTypesDTO.createdUser;
    }
   return idProofType;
  }
  public convertEntityToDto(idProofTypeObject: IdProofTypes): IdProofTypesDTO {
    const idProofTypesDTO= new IdProofTypesDTO;
    idProofTypesDTO.idProofTypeId = idProofTypeObject.idProofTypeId;
    idProofTypesDTO.idProofType = idProofTypeObject.idProofType;
    idProofTypesDTO.isActive = idProofTypeObject.isActive;
    idProofTypesDTO.createdAt = idProofTypeObject.createdAt;
    idProofTypesDTO.updatedAt = idProofTypeObject.updatedAt;
    idProofTypesDTO.createdUser = idProofTypeObject.createdUser;
    idProofTypesDTO.updatedUser = idProofTypeObject.updatedUser;
    idProofTypesDTO.versionFlag = idProofTypeObject.versionFlag;
    return idProofTypesDTO;
  }
}
